import { ASSIGNMENT_CONFIGURATION_REPOSITORY, GetAssignmentConfigurationsUseCase, GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE } from '@module/assignment';
export var assignmentConfigurationUseCaseProviders = [{
  provide: GET_ASSIGNMENT_CONFIGURATIONS_USE_CASE,
  useFactory: function useFactory(assignmentConfigurationRepository) {
    return new GetAssignmentConfigurationsUseCase(assignmentConfigurationRepository);
  },
  inject: [ASSIGNMENT_CONFIGURATION_REPOSITORY]
}];